<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showConfigurationGroup"
      scrollable
      no-close-on-backdrop
      title="Configuración grupo"
      cancel-variant="outline-secondary"
    >
      <b-row>
        <b-col md="6" style="height:80vh; overflow:scroll">
          <draggable
            :list="listEquiposMostrar"
            tag="ul"
            group="people"
            class="list-group list-group-flush cursor-move"
          >
            <b-list-group-item
              v-for="(listItem, index) in listEquiposMostrar"
              :key="index"
              tag="li"
            >
              <div class="d-flex">
                <div class="ml-25">
                  <img :src="listItem.foto" alt="" width="30" />
                  <b style="font-size:12px" class="ml-1"
                    >{{ listItem.apodo }} {{ listItem.alias_equipo }}</b
                  >
                </div>
              </div>
            </b-list-group-item>
          </draggable>
        </b-col>

        <!-- people group 2 -->
        <b-col md="6" class="mt-sm-2 mt-md-0">
          <h6 class="text-primary font-weight-bold mb-2">
            Grupo conformado por:
          </h6>

          <!-- draggable -->
          <draggable
            :list="listTeamsAsign"
            tag="ul"
            group="people"
            class="list-group list-group-flush cursor-move"
          >
            <b-list-group-item
              v-for="(listItem, index) in listTeamsAsign"
              :key="index"
              tag="li"
            >
              <div class="d-flex">
                <b-avatar :text="(index + 1).toString()" />
                <div class="ml-25">
                  <img :src="listItem.foto" alt="" width="30" />
                  <b style="font-size:12px" class="ml-1"
                    >{{ listItem.apodo }} {{ listItem.alias_equipo }}</b
                  >
                </div>
              </div>
            </b-list-group-item>
          </draggable>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <template>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="irGenerarFixture"
            >
              Continuar
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="cancelar"
            >
              Cancelar
            </b-button>
          </template>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  //   BCard,
  // BCardText,
  BRow,
  BCol,
  BListGroupItem,
  BAvatar,
  BButton,
  //   BFormGroup,
  //   BFormInput,
  //   BTable,
  //   BMedia,
  //   BAvatar,
  //   VBTooltip,
  //   BBadge,
  //   BButtonGroup,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import draggable from 'vuedraggable'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  components: {
    BRow,
    BCol,
    BListGroupItem,
    BAvatar,
    // Prism,
    draggable,
    // BCard,
    // BCardText,
    // BFormGroup,
    // BFormInput,
    BButton,
  },
  props: {
    listEquiposSorteo: Array,
    listTeamsAsign: Array,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    // const listTeamsAsign = ref([])
    let results
    const listEquiposMostrar = computed(() => {
      if (props.listTeamsAsign.value !== undefined) {
        results = props.listEquiposSorteo.filter(
          ({ id_equipo: id1 }) =>
            // eslint-disable-next-line
            !props.listTeamsAsign.value.some(
            // eslint-disable-next-line
              ({ id_equipo: id2 }) => id2 === id1
            // eslint-disable-next-line
            )
        )
      } else {
        results = props.listEquiposSorteo
      }
      // console.log(results)
      return results
    })
    // function resetModal(bvModalEvt) {
    //   bvModalEvt.preventDefault()
    //   //   console.log(emit)
    //   //   emit('recargar', props.playerSelected.id_equipo)
    //   console.log('hidden')
    //   // initPlayer()
    //   //       this.$emit('closeModal', false)
    // }
    // const nueva = computed(
    //   // eslint-disable-next-line
    //   () => props.continuar
    //   // console.log(props.continuar)
    //   // if (!props.continuar) listTeamsAsign.value = []
    //   // eslint-disable-next-line
    // )
    // console.log(nueva)
    function irGenerarFixture() {
      // console.log('generar')
      emit('generaFixture', props.listTeamsAsign)
      store.commit('someVariables/UPDATE_ACTION_CONFIGURATION_GROUP', false)
    }
    function cancelar() {
      // console.log(props)
      store.commit('someVariables/UPDATE_ACTION_CONFIGURATION_GROUP', false)
      props.listTeamsAsign = []
    }
    return {
      // listTeamsAsign,
      listEquiposMostrar,
      //   resetModal,
      irGenerarFixture,
      cancelar,
    }
  },
}
</script>
